const AlignLeftOutline = require('@ant-design/icons/lib/outline/AlignLeftOutline').default;
const AlignRightOutline = require('@ant-design/icons/lib/outline/AlignRightOutline').default;
const AppstoreOutline = require('@ant-design/icons/lib/outline/AppstoreOutline').default;
const AppstoreFill = require('@ant-design/icons/lib/fill/AppstoreFill').default;
const AreaChartOutline = require('@ant-design/icons/lib/outline/AreaChartOutline').default;
const ArrowDownOutline = require('@ant-design/icons/lib/outline/ArrowDownOutline').default;
const ArrowLeftOutline = require('@ant-design/icons/lib/outline/ArrowLeftOutline').default;
const ArrowRightOutline = require('@ant-design/icons/lib/outline/ArrowRightOutline').default;
const ArrowUpOutline = require('@ant-design/icons/lib/outline/ArrowUpOutline').default;
const BellOutline = require('@ant-design/icons/lib/outline/BellOutline').default;
const BellFill = require('@ant-design/icons/lib/fill/BellFill').default;
const BoldOutline = require('@ant-design/icons/lib/outline/BoldOutline').default;
const CalendarOutline = require('@ant-design/icons/lib/outline/CalendarOutline').default;
const CalendarFill = require('@ant-design/icons/lib/fill/CalendarFill').default;
const CameraOutline = require('@ant-design/icons/lib/outline/CameraOutline').default;
const CameraFill = require('@ant-design/icons/lib/fill/CameraFill').default;
const CaretDownOutline = require('@ant-design/icons/lib/outline/CaretDownOutline').default;
const CaretDownFill = require('@ant-design/icons/lib/fill/CaretDownFill').default;
const CaretUpOutline = require('@ant-design/icons/lib/outline/CaretUpOutline').default;
const CaretUpFill = require('@ant-design/icons/lib/fill/CaretUpFill').default;
const CheckCircleOutline = require('@ant-design/icons/lib/outline/CheckCircleOutline').default;
const CheckCircleFill = require('@ant-design/icons/lib/fill/CheckCircleFill').default;
const CheckOutline = require('@ant-design/icons/lib/outline/CheckOutline').default;
const CheckSquareOutline = require('@ant-design/icons/lib/outline/CheckSquareOutline').default;
const CheckSquareFill = require('@ant-design/icons/lib/fill/CheckSquareFill').default;
const ClockCircleOutline = require('@ant-design/icons/lib/outline/ClockCircleOutline').default;
const ClockCircleFill = require('@ant-design/icons/lib/fill/ClockCircleFill').default;
const CloseCircleOutline = require('@ant-design/icons/lib/outline/CloseCircleOutline').default;
const CloseCircleFill = require('@ant-design/icons/lib/fill/CloseCircleFill').default;
const CloseOutline = require('@ant-design/icons/lib/outline/CloseOutline').default;
const CopyOutline = require('@ant-design/icons/lib/outline/CopyOutline').default;
const CopyFill = require('@ant-design/icons/lib/fill/CopyFill').default;
const CreditCardOutline = require('@ant-design/icons/lib/outline/CreditCardOutline').default;
const CreditCardFill = require('@ant-design/icons/lib/fill/CreditCardFill').default;
const DeleteOutline = require('@ant-design/icons/lib/outline/DeleteOutline').default;
const DeleteFill = require('@ant-design/icons/lib/fill/DeleteFill').default;
const DownOutline = require('@ant-design/icons/lib/outline/DownOutline').default;
const DownloadOutline = require('@ant-design/icons/lib/outline/DownloadOutline').default;
const EditOutline = require('@ant-design/icons/lib/outline/EditOutline').default;
const EditFill = require('@ant-design/icons/lib/fill/EditFill').default;
const ExclamationCircleOutline = require('@ant-design/icons/lib/outline/ExclamationCircleOutline').default;
const ExclamationCircleFill = require('@ant-design/icons/lib/fill/ExclamationCircleFill').default;
const EyeInvisibleOutline = require('@ant-design/icons/lib/outline/EyeInvisibleOutline').default;
const EyeInvisibleFill = require('@ant-design/icons/lib/fill/EyeInvisibleFill').default;
const EyeOutline = require('@ant-design/icons/lib/outline/EyeOutline').default;
const EyeFill = require('@ant-design/icons/lib/fill/EyeFill').default;
const FallOutline = require('@ant-design/icons/lib/outline/FallOutline').default;
const FileExcelOutline = require('@ant-design/icons/lib/outline/FileExcelOutline').default;
const FileExcelFill = require('@ant-design/icons/lib/fill/FileExcelFill').default;
const FileImageOutline = require('@ant-design/icons/lib/outline/FileImageOutline').default;
const FileImageFill = require('@ant-design/icons/lib/fill/FileImageFill').default;
const FileOutline = require('@ant-design/icons/lib/outline/FileOutline').default;
const FileFill = require('@ant-design/icons/lib/fill/FileFill').default;
const FilePdfOutline = require('@ant-design/icons/lib/outline/FilePdfOutline').default;
const FilePdfFill = require('@ant-design/icons/lib/fill/FilePdfFill').default;
const FileTextOutline = require('@ant-design/icons/lib/outline/FileTextOutline').default;
const FileTextFill = require('@ant-design/icons/lib/fill/FileTextFill').default;
const FileWordOutline = require('@ant-design/icons/lib/outline/FileWordOutline').default;
const FileWordFill = require('@ant-design/icons/lib/fill/FileWordFill').default;
const FileZipOutline = require('@ant-design/icons/lib/outline/FileZipOutline').default;
const FileZipFill = require('@ant-design/icons/lib/fill/FileZipFill').default;
const FilterOutline = require('@ant-design/icons/lib/outline/FilterOutline').default;
const FilterFill = require('@ant-design/icons/lib/fill/FilterFill').default;
const FolderOpenOutline = require('@ant-design/icons/lib/outline/FolderOpenOutline').default;
const FolderOpenFill = require('@ant-design/icons/lib/fill/FolderOpenFill').default;
const FolderOutline = require('@ant-design/icons/lib/outline/FolderOutline').default;
const FolderFill = require('@ant-design/icons/lib/fill/FolderFill').default;
const FontSizeOutline = require('@ant-design/icons/lib/outline/FontSizeOutline').default;
const FullscreenExitOutline = require('@ant-design/icons/lib/outline/FullscreenExitOutline').default;
const FullscreenOutline = require('@ant-design/icons/lib/outline/FullscreenOutline').default;
const GoldOutline = require('@ant-design/icons/lib/outline/GoldOutline').default;
const HeartOutline = require('@ant-design/icons/lib/outline/HeartOutline').default;
const HeartFill = require('@ant-design/icons/lib/fill/HeartFill').default;
const HistoryOutline = require('@ant-design/icons/lib/outline/HistoryOutline').default;
const HomeOutline = require('@ant-design/icons/lib/outline/HomeOutline').default;
const HomeFill = require('@ant-design/icons/lib/fill/HomeFill').default;
const InfoCircleOutline = require('@ant-design/icons/lib/outline/InfoCircleOutline').default;
const InfoCircleFill = require('@ant-design/icons/lib/fill/InfoCircleFill').default;
const InfoOutline = require('@ant-design/icons/lib/outline/InfoOutline').default;
const ItalicOutline = require('@ant-design/icons/lib/outline/ItalicOutline').default;
const LayoutOutline = require('@ant-design/icons/lib/outline/LayoutOutline').default;
const LayoutFill = require('@ant-design/icons/lib/fill/LayoutFill').default;
const LeftOutline = require('@ant-design/icons/lib/outline/LeftOutline').default;
const LikeOutline = require('@ant-design/icons/lib/outline/LikeOutline').default;
const LikeFill = require('@ant-design/icons/lib/fill/LikeFill').default;
const LineOutline = require('@ant-design/icons/lib/outline/LineOutline').default;
const LinkOutline = require('@ant-design/icons/lib/outline/LinkOutline').default;
const LoadingOutline = require('@ant-design/icons/lib/outline/LoadingOutline').default;
const LockOutline = require('@ant-design/icons/lib/outline/LockOutline').default;
const LockFill = require('@ant-design/icons/lib/fill/LockFill').default;
const LogoutOutline = require('@ant-design/icons/lib/outline/LogoutOutline').default;
const MenuOutline = require('@ant-design/icons/lib/outline/MenuOutline').default;
const MenuFoldOutline = require('@ant-design/icons/lib/outline/MenuFoldOutline').default;
const MenuUnfoldOutline = require('@ant-design/icons/lib/outline/MenuUnfoldOutline').default;
const MessageOutline = require('@ant-design/icons/lib/outline/MessageOutline').default;
const MessageFill = require('@ant-design/icons/lib/fill/MessageFill').default;
const MinusCircleOutline = require('@ant-design/icons/lib/outline/MinusCircleOutline').default;
const MinusCircleFill = require('@ant-design/icons/lib/fill/MinusCircleFill').default;
const MinusOutline = require('@ant-design/icons/lib/outline/MinusOutline').default;
const MoreOutline = require('@ant-design/icons/lib/outline/MoreOutline').default;
const PieChartOutline = require('@ant-design/icons/lib/outline/PieChartOutline').default;
const PieChartFill = require('@ant-design/icons/lib/fill/PieChartFill').default;
const PictureOutline = require('@ant-design/icons/lib/outline/PictureOutline').default;
const PictureFill = require('@ant-design/icons/lib/fill/PictureFill').default;
const PlusCircleOutline = require('@ant-design/icons/lib/outline/PlusCircleOutline').default;
const PlusCircleFill = require('@ant-design/icons/lib/fill/PlusCircleFill').default;
const PlusOutline = require('@ant-design/icons/lib/outline/PlusOutline').default;
const PrinterOutline = require('@ant-design/icons/lib/outline/PrinterOutline').default;
const PrinterFill = require('@ant-design/icons/lib/fill/PrinterFill').default;
const ProjectOutline = require('@ant-design/icons/lib/outline/ProjectOutline').default;
const ProjectFill = require('@ant-design/icons/lib/fill/ProjectFill').default;
const PushpinOutline = require('@ant-design/icons/lib/outline/PushpinOutline').default;
const PushpinFill = require('@ant-design/icons/lib/fill/PushpinFill').default;
const QuestionCircleOutline = require('@ant-design/icons/lib/outline/QuestionCircleOutline').default;
const QuestionCircleFill = require('@ant-design/icons/lib/fill/QuestionCircleFill').default;
const ReadOutline = require('@ant-design/icons/lib/outline/ReadOutline').default;
const ReadFill = require('@ant-design/icons/lib/fill/ReadFill').default;
const RightOutline = require('@ant-design/icons/lib/outline/RightOutline').default;
const RiseOutline = require('@ant-design/icons/lib/outline/RiseOutline').default;
const RobotOutline = require('@ant-design/icons/lib/outline/RobotOutline').default;
const SafetyOutline = require('@ant-design/icons/lib/outline/SafetyOutline').default;
const SaveOutline = require('@ant-design/icons/lib/outline/SaveOutline').default;
const SaveFill = require('@ant-design/icons/lib/fill/SaveFill').default;
const ScanOutline = require('@ant-design/icons/lib/outline/ScanOutline').default;
const SearchOutline = require('@ant-design/icons/lib/outline/SearchOutline').default;
const SettingOutline = require('@ant-design/icons/lib/outline/SettingOutline').default;
const SettingFill = require('@ant-design/icons/lib/fill/SettingFill').default;
const ShopOutline = require('@ant-design/icons/lib/outline/ShopOutline').default;
const ShopFill = require('@ant-design/icons/lib/fill/ShopFill').default;
const SmileOutline = require('@ant-design/icons/lib/outline/SmileOutline').default;
const SmileFill = require('@ant-design/icons/lib/fill/SmileFill').default;
const SolutionOutline = require('@ant-design/icons/lib/outline/SolutionOutline').default;
const StarOutline = require('@ant-design/icons/lib/outline/StarOutline').default;
const StarFill = require('@ant-design/icons/lib/fill/StarFill').default;
const SwapOutline = require('@ant-design/icons/lib/outline/SwapOutline').default;
const SyncOutline = require('@ant-design/icons/lib/outline/SyncOutline').default;
const TeamOutline = require('@ant-design/icons/lib/outline/TeamOutline').default;
const UnderlineOutline = require('@ant-design/icons/lib/outline/UnderlineOutline').default;
const UnlockOutline = require('@ant-design/icons/lib/outline/UnlockOutline').default;
const UnlockFill = require('@ant-design/icons/lib/fill/UnlockFill').default;
const UnorderedListOutline = require('@ant-design/icons/lib/outline/UnorderedListOutline').default;
const UpOutline = require('@ant-design/icons/lib/outline/UpOutline').default;
const UploadOutline = require('@ant-design/icons/lib/outline/UploadOutline').default;
const UserAddOutline = require('@ant-design/icons/lib/outline/UserAddOutline').default;
const UserDeleteOutline = require('@ant-design/icons/lib/outline/UserDeleteOutline').default;
const UserOutline = require('@ant-design/icons/lib/outline/UserOutline').default;
const WarningOutline = require('@ant-design/icons/lib/outline/WarningOutline').default;
const WarningFill = require('@ant-design/icons/lib/fill/WarningFill').default;
const WifiOutline = require('@ant-design/icons/lib/outline/WifiOutline').default;

module.exports = {
	AlignLeftOutline,
	AlignRightOutline,
	AppstoreOutline,
	AppstoreFill,
	AreaChartOutline,
	ArrowDownOutline,
	ArrowLeftOutline,
	ArrowRightOutline,
	ArrowUpOutline,
	BellOutline,
	BellFill,
	BoldOutline,
	CalendarOutline,
	CalendarFill,
	CameraOutline,
	CameraFill,
	CaretDownOutline,
	CaretDownFill,
	CaretUpOutline,
	CaretUpFill,
	CheckCircleOutline,
	CheckCircleFill,
	CheckOutline,
	CheckSquareOutline,
	CheckSquareFill,
	ClockCircleOutline,
	ClockCircleFill,
	CloseCircleOutline,
	CloseCircleFill,
	CloseOutline,
	CopyOutline,
	CopyFill,
	CreditCardOutline,
	CreditCardFill,
	DeleteOutline,
	DeleteFill,
	DownOutline,
	DownloadOutline,
	EditOutline,
	EditFill,
	ExclamationCircleOutline,
	ExclamationCircleFill,
	EyeInvisibleOutline,
	EyeInvisibleFill,
	EyeOutline,
	EyeFill,
	FallOutline,
	FileExcelOutline,
	FileExcelFill,
	FileImageOutline,
	FileImageFill,
	FileOutline,
	FileFill,
	FilePdfOutline,
	FilePdfFill,
	FileTextOutline,
	FileTextFill,
	FileWordOutline,
	FileWordFill,
	FileZipOutline,
	FileZipFill,
	FilterOutline,
	FilterFill,
	FolderOpenOutline,
	FolderOpenFill,
	FolderOutline,
	FolderFill,
	FontSizeOutline,
	FullscreenExitOutline,
	FullscreenOutline,
	GoldOutline,
	HeartOutline,
	HeartFill,
	HistoryOutline,
	HomeOutline,
	HomeFill,
	InfoCircleOutline,
	InfoCircleFill,
	InfoOutline,
	ItalicOutline,
	LayoutOutline,
	LayoutFill,
	LeftOutline,
	LikeOutline,
	LikeFill,
	LineOutline,
	LinkOutline,
	LoadingOutline,
	LockOutline,
	LockFill,
	LogoutOutline,
	MenuOutline,
	MenuFoldOutline,
	MenuUnfoldOutline,
	MessageOutline,
	MessageFill,
	MinusCircleOutline,
	MinusCircleFill,
	MinusOutline,
	MoreOutline,
	PieChartOutline,
	PieChartFill,
	PictureOutline,
	PictureFill,
	PlusCircleOutline,
	PlusCircleFill,
	PlusOutline,
	PrinterOutline,
	PrinterFill,
	ProjectOutline,
	ProjectFill,
	PushpinOutline,
	PushpinFill,
	QuestionCircleOutline,
	QuestionCircleFill,
	ReadOutline,
	ReadFill,
	RightOutline,
	RiseOutline,
	RobotOutline,
	SafetyOutline,
	SaveOutline,
	SaveFill,
	ScanOutline,
	SearchOutline,
	SettingOutline,
	SettingFill,
	ShopOutline,
	ShopFill,
	SmileOutline,
	SmileFill,
	SolutionOutline,
	StarOutline,
	StarFill,
	SwapOutline,
	SyncOutline,
	TeamOutline,
	UnderlineOutline,
	UnlockOutline,
	UnlockFill,
	UnorderedListOutline,
	UpOutline,
	UploadOutline,
	UserAddOutline,
	UserDeleteOutline,
	UserOutline,
	WarningOutline,
	WarningFill,
	WifiOutline,
};
